/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeliveryStatusDtoCreate } from '../../models/delivery-status-dto-create';
import { DeliveryStatusItem } from '../../models/delivery-status-item';

export interface DeliveryStatusControllerCreate$Params {
      body: DeliveryStatusDtoCreate
}

export function deliveryStatusControllerCreate(http: HttpClient, rootUrl: string, params: DeliveryStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusItem;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryStatusControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryStatusItem;
      }>;
    })
  );
}

deliveryStatusControllerCreate.PATH = '/delivery-status';
